import React, { useState } from "react";
import EditableSpan from "../components/EditableSpan";
import { getEntityFullName } from "../components/tools";

export const LessonCaptionBlock = ({ lesson, save, pagelanguage, activelanguage, editableName, showAllLanguages = false }) => {
    const [lessonUpdateForm, setLessonUpdateForm] = useState([])

    const changeLessonNameHandler = (data, key, val) => {
        const temp = lessonUpdateForm
        if (temp.some(item => item.id === data.id)) {
            //console.log("Object found inside the array.");
            setLessonUpdateForm(
                lessonUpdateForm => lessonUpdateForm.map(
                    item => {
                        if (item.id === data.id) {
                            item[key] = val
                        }
                        return item
                    }
                )
            )

        } else {
            //console.log("Object not found.");
            setLessonUpdateForm([...lessonUpdateForm, data])
        }
    }

    return (
        <div className="align-lessons-start d-flex" onClick={() => {
            let default_data = { id: lesson.id }
            activelanguage.map((lang_item, index) =>
                default_data['name_' + lang_item.code] = lesson['name_' + lang_item.code]
            )
            changeLessonNameHandler(default_data)
        }}>
            {showAllLanguages
                ? (
                    <span style={{ width: "100%", marginLeft: "10px" }}>{getEntityFullName(lesson, activelanguage)}</span>
                )
                : (
                    activelanguage.length && activelanguage
                        .filter(lang => lang.code === pagelanguage)
                        .map((lang_item, index) =>
                            <div key={lang_item.name} >
                                <EditableSpan
                                    key={index}
                                    item={lesson}
                                    updateHandler={changeLessonNameHandler}
                                    fieldName={'name_'}
                                    langCode={lang_item.code}
                                    textValue={lesson['name_' + lang_item.code]}
                                    editable={editableName}
                                />
                            </div>
                        )
                )}

            {
                lessonUpdateForm.some(lessonUpdateForm => lessonUpdateForm.id === lesson.id && lessonUpdateForm.updated === 1)
                &&
                <img src="/img/save.png"
                    onClick={() => {
                        save(lessonUpdateForm);
                        setLessonUpdateForm([]);
                    }}
                    className="CardBlockHederImg ml-3" alt="" />
            }
        </div>

    )
};

